
import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconResolverService {
    private iconRegistry = inject(MatIconRegistry);
    private sanitizer = inject(DomSanitizer);

    private folders  = new Map<string, string>()

    constructor() {
        this.folders.set("figma", 'figma');
        this.folders.set("magic-duotone", 'magic/Duotone');
        this.folders.set("magic-duotonestyleduo", 'magic/DuotoneStyleDuo');
        this.folders.set("magic-filled", 'magic/Filled');
        this.folders.set("magic-fillednostyle", 'magic/FilledNoStyle');
        this.folders.set("magic-light", 'magic/Light');
        this.folders.set("magic-regular", 'magic/Regular');

    }

    /**
     *  Initialise un résolveur d'icônes SVG basé sur un dossier donné. -> folders
     *  basePath Chemin de base vers les icônes SVG
     */
    registerIconResolver(basePath = 'assets/images/icons/') {
        this.iconRegistry.addSvgIconResolver((name: string, namespace?: string): SafeResourceUrl | null => {
                let result: SafeResourceUrl | null = null;
                let folder : string | undefined;
                if(namespace) {
                    folder = this.folders.get(namespace) ;
                }

                if (!folder) {
                    result=null
                } else {
                    result = this.sanitizer.bypassSecurityTrustResourceUrl( `${ basePath }${ folder }/${ name }.svg` )
                }
                return result;
            }
        );
    }

}
